import React from 'react'
import { Controller } from 'react-hook-form'
import DatePicker from 'react-datepicker'
import DateInput from './date-input'

const DateSelect = props => {
  return <div className='row'>
    <label className='reconcile-label col-lg-4' htmlFor={props.name}>{props.label}</label>
    <div className='col-lg-7'>
      <Controller
        control={props.control}
        name={props.name}
        render={({ field }) => (
          <DatePicker
            name={props.name}
            customInput={<DateInput />}
            onChange={date => field.onChange(date && date.format('MM/DD/YYYY'))}
            selected={field.value && moment(new Date(field.value))}
          />
        )}
      />
    </div>
  </div>
}

export default DateSelect
